import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "sourcetype"
    }}>{`SourceType`}</h1>
    <p>{`The source type of alternate or actual text`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SOURCE_CUSTOM`}</strong>{` = 1934902125`}</p>
      <p parentName="blockquote">{`Custom Text`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SOURCE_XMP_ALT_TEXT`}</strong>{` = 1934907489`}</p>
      <p parentName="blockquote">{`XMP Alt Text`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SOURCE_XMP_EXTENDED_DESCRIPTION`}</strong>{` = 1934907493`}</p>
      <p parentName="blockquote">{`XMP Extended Description`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SOURCE_XMP_TITLE`}</strong>{` = 1934907508`}</p>
      <p parentName="blockquote">{`XMP Title`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SOURCE_XMP_DESCRIPTION`}</strong>{` = 1934907492`}</p>
      <p parentName="blockquote">{`XMP Description`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SOURCE_XMP_HEADLINE`}</strong>{` = 1934907496`}</p>
      <p parentName="blockquote">{`XMP Headline`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SOURCE_XMP_OTHER`}</strong>{` = 1934907503`}</p>
      <p parentName="blockquote">{`User specified XMP metadata property`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SOURCE_XML_STRUCTURE`}</strong>{` = 1934907507`}</p>
      <p parentName="blockquote">{`XML Structure`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      